import { useCallback } from 'react'

const sortFilterMap = {
  'recently added': 'createdAt:desc',
  'most liked': 'likeCount:desc'
}

const useEventFilters = () => {
  const getEventFilters = useCallback(({ sort, start, ...rest }) => {
    const eventSort = sortFilterMap[sort?.toLowerCase()] || ''
    return { sort: eventSort, ...rest }
  }, [])

  return { getEventFilters }
}

export default useEventFilters
